// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"139a4b2c75f89318","997":"0187b480f04c2e5a"}[chunkId] + ".css";
};